var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAac = function SvgAac(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#21852B",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.384 17.5h-.906l1.38-4h1.09l1.38 4H7.42L6.42 14.414h-.031zm-.057-1.572h2.141v.66h-2.14zM9.663 17.5h-.906l1.38-4h1.09l1.38 4H11.7L10.7 14.414h-.032zm-.056-1.572h2.14v.66h-2.14zm6.987-1.028h-.855a.8.8 0 0 0-.096-.295.8.8 0 0 0-.185-.222.8.8 0 0 0-.262-.14 1 1 0 0 0-.318-.05.95.95 0 0 0-.541.155 1 1 0 0 0-.358.445q-.126.291-.127.707 0 .428.127.719.129.29.36.44a.96.96 0 0 0 .533.148q.17 0 .314-.045a.755.755 0 0 0 .447-.344.8.8 0 0 0 .106-.285l.855.004q-.033.274-.166.531-.13.254-.353.455a1.7 1.7 0 0 1-.527.316 2 2 0 0 1-.69.116q-.535 0-.957-.242a1.7 1.7 0 0 1-.664-.702q-.242-.459-.242-1.111 0-.654.246-1.113.246-.46.668-.7.422-.242.95-.242.346 0 .644.098t.529.285q.231.186.375.455.147.27.187.617"
  })));
};
export default SvgAac;